<template>
  <section class="landing-root">
    <!-- Botões topo -->
    <div class="top-actions">
      <!--<button class="btn-outline">Cadastre-se</button> -->
    <button class="login-btn" @click="$router.push('/login')">
      Entre
    </button>
    </div>

    <!-- Onda só aparece no desktop -->
    <div class="wave-top desktop-only" aria-hidden="true">
      <svg viewBox="0 0 1440 200" preserveAspectRatio="none">
        <path fill="url(#gradiente)"
          d="M0,160L48,154.7C96,149,192,139,288,154.7C384,171,480,213,576,224C672,235,768,213,864,192C960,171,1056,149,1152,154.7C1248,160,1344,192,1392,208L1440,224L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z" />
        <defs>
          <linearGradient id="gradiente" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stop-color="#0d3927" />
            <stop offset="100%" stop-color="#145a32" />
          </linearGradient>
        </defs>
      </svg>
    </div>

    <!-- Conteúdo principal -->
    <div class="landing-inner">
      <!-- Texto -->
      <div class="content fade-in-left">
        <h1 class="headline">Gestão inteligente da sua produção têxtil</h1>
        <p class="lead">
          Controle cada etapa, otimize processos e acompanhe os resultados em tempo real.
        </p>
      </div>

      <!-- Celular -->
      <div class="phone-wrap fade-in-right">
        <img src="@/assets/celular3.png" alt="App preview no celular" />
      </div>
    </div>

    <!-- Funcionalidades -->
    <div class="features">
      <h2>Funcionalidades que fazem diferença</h2>
      <div class="features-grid">
        <div class="feature-card">
          <span class="icon">📊</span>
          <h3>Relatórios em tempo real</h3>
          <p>Acompanhe indicadores de produção e desempenho da equipe.</p>
        </div>
        <div class="feature-card">
          <span class="icon">⏱️</span>
          <h3>Controle de etapas</h3>
          <p>Registre e monitore cada fase da produção têxtil.</p>
        </div>
        <div class="feature-card">
          <span class="icon">👥</span>
          <h3>Gestão de equipes</h3>
          <p>Organize os times e calcule tempos médios de execução.</p>
        </div>
        <div class="feature-card">
          <span class="icon">🧾</span>
          <h3>Relatórios avançados</h3>
          <p>Dados completos para otimizar processos e reduzir custos.</p>
        </div>
      </div>
    </div>

    <!-- Planos -->
    <div class="plans container">
      <h2>Nossos Planos</h2>
      <div class="plans-grid">

        <!-- <div class="plan-card">
          <h3>Semestral</h3>
          <p>Ideal para pequenas e médias confecções</p>
          <span class="price">6x de R$ 379,90</span>
          <ul>
            <li>✔️ Controle de produção</li>
            <li>✔️ Gestão de equipes</li>
            <li>✔️ Relatórios básicos</li>
          </ul>
        </div>

        <div class="plan-card destaque">
          <h3>Anual</h3>
          <p>Para fábricas em crescimento</p>
          <span class="price">12x de R$ 329,90 </span>
          <ul>
            <li>✔️ Tudo do Semestral</li>
            <li>✔️ Relatórios avançados</li>
            <li>✔️ Suporte prioritário</li>
          </ul>
        </div> -->

        <div class="plan-card">
          <h3>Sob Demanda</h3>
          <p>Grandes indústrias têxteis</p>
          <span class="price">Sob consulta</span>
          <ul>
            <li>✔️ Personalização completa</li>
            <li>✔️ Treinamento da equipe</li>
            <li>✔️ Consultoria dedicada</li>
          </ul>
        </div>
        
      </div>
    </div>
    <section class="ai-section">
  <div class="ai-container">
    
    <!-- Texto -->
    <div class="ai-content">
      <h2>Inteligência Artificial aplicada à produção têxtil</h2>
      <p class="ai-lead">
        O LinhaTex utiliza inteligência artificial para analisar dados produtivos,
        identificar gargalos, prever atrasos e sugerir melhorias nos processos.
      </p>

      <ul class="ai-list">
        <li>✔️ Análise inteligente de desempenho produtivo</li>
        <li>✔️ Previsão de atrasos e gargalos</li>
        <li>✔️ Otimização automática de processos</li>
        <li>✔️ Decisões baseadas em dados reais</li>
      </ul>
    </div>

    <!-- Imagem -->
    <div class="ai-image">
      <img src="@/assets/imagem1.png" alt="Inteligência artificial aplicada à produção têxtil no LinhaTex">
    </div>

  </div>
</section>
    <section class="seo-text">
      <h2>LinhaTex – Sistema de Gestão da Produção Têxtil</h2>
      <p>
        O LinhaTex é um software especializado em gestão da produção têxtil,
        desenvolvido para confecções, fábricas e indústrias do setor.
        Com o LinhaTex, é possível controlar etapas produtivas, equipes,
        indicadores e relatórios em tempo real.
      </p>
    </section>
    <AddFooter />
  </section>
</template>

<script>
import { useHead } from '@vueuse/head'
import AddFooter from '@/components/Footer.vue'

export default {
  name: "LandingHome",
  components: { AddFooter },
  setup() {
    useHead({
      title: 'LinhaTex | Gestão Inteligente da Produção Têxtil',
      meta: [
        {
          name: 'description',
          content: 'LinhaTex é um sistema completo para gestão da produção têxtil. Controle etapas, equipes e relatórios em tempo real.'
        },
        {
          name: 'keywords',
          content: 'LinhaTex, gestão têxtil, produção têxtil, sistema de confecção, controle de produção'
        },

        // Open Graph
        { property: 'og:title', content: 'LinhaTex | Gestão da Produção Têxtil' },
        { property: 'og:description', content: 'Controle total da sua produção têxtil com o LinhaTex.' },
        { property: 'og:image', content: 'https://linhatex.com/og-image.png' },
        { property: 'og:type', content: 'website' }
      ]
    })
  },
  methods: {
    async Login() {
      try {
        await this.$router.push('/login')
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style scoped>
:root {
  --verde-escuro: #0d3927;
  --verde-claro: #145a32;
  --bg: #f6f7f6;
  --card: #ffffff;
}
.seo-text {
  max-width: 900px;
  margin: 40px auto;
  font-size: 0.95rem;
  color: #333;
}
.ai-section {
  padding: 80px 20px;
  background: #f2f5f3;
}

.ai-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  align-items: center;
  gap: 50px;
}

.ai-content h2 {
  font-size: 2.2rem;
  color: var(--verde-escuro);
  margin-bottom: 15px;
}

.ai-lead {
  font-size: 1.1rem;
  color: #444;
  margin-bottom: 20px;
}

.ai-list {
  list-style: none;
  padding: 0;
  font-size: 1rem;
  color: #333;
}

.ai-list li {
  margin-bottom: 10px;
}

.ai-image img {
  width: 100%;
  display: block;
}
.login-btn {
  background: #fff;
  color: (var(--verde-escuro));
  border: none;
  border-radius: 999px;
  padding: 12px 28px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all .3s ease;
  box-shadow: 0 8px 24px rgba(13, 57, 39, .25);
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(13, 57, 39, .35);
}

.login-btn:active {
  transform: scale(.98);
}

.login-btn:focus-visible {
  outline: 3px solid rgba(20, 90, 50, .25);
  outline-offset: 3px;
}

@media (max-width: 768px) {
  .login-btn {
    width: 100%;
    max-width: 170px;
    padding: 11px 22px;
    font-size: 14px;
  }
}
/* Mobile */
@media (max-width: 768px) {
  .ai-container {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .ai-list {
    text-align: left;
    display: inline-block;
  }
}
.top-actions {
  position: absolute;
  top: 15px;
  right: 20px;
  display: flex;
  gap: 12px;
  z-index: 10;
}

.top-actions .btn-outline,
.top-actions .btn-solid {
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
}

.btn-outline {
  background: transparent;
  border: 2px solid white;
  color: white;
}

.btn-outline:hover {
  background: rgba(255, 255, 255, 0.1);
}

.btn-solid {
  background: white;
  color: var(--verde-escuro);
}

.btn-solid:hover {
  background: #f0f0f0;
}

@media (max-width: 768px) {
  .top-actions {
    display: flex;
    margin-right: 40px;
    justify-content: flex-end;
    position: static;
    /* não mais absoluto */
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .btn-outline,
  .btn-solid {
    border: 2px solid var(--verde-claro);
    color: white;
    background: var(--verde-claro);
  }

  .btn-solid {
    background: var(--verde-claro);
    color: white;
  }
}

/* Onda só aparece no desktop */
.wave-top svg {
  width: 100%;
  height: 120px;
}

.desktop-only {
  display: block;
}

@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }
}

.landing-inner {
  position: relative;
  margin-top: -120px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 60px;
  padding: 0 20px;
  flex-wrap: wrap;
  z-index: 2;
}

/* Texto */
.content {
  max-width: 500px;
}

.headline {
  font-size: 2.8rem;
  font-weight: 800;
  color: var(--verde-escuro);
  margin-bottom: 15px;
}

.lead {
  font-size: 1.25rem;
  color: #444;
  margin-bottom: 15px;
}

/* Celular */
.phone-wrap {
  position: relative;
  width: 600px;
  max-width: 100%;
  filter: drop-shadow(0 20px 30px rgba(0, 0, 0, 0.25));
}

.phone-wrap img {
  width: 100%;
  display: block;
}

/* Animações */
.fade-in-left {
  animation: fadeInLeft 1s ease forwards;
}

.fade-in-right {
  animation: fadeInRight 1s ease forwards;
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-60px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(60px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Funcionalidades */
.features {
  background: var(--verde-claro);
  color: #fff;
  padding: 60px 20px;
  text-align: center;
}

.features h2 {
  font-size: 2rem;
  margin-bottom: 40px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 30px;
}

.feature-card {
  background: white;
  color: #0d3927;
  border-radius: 12px;
  padding: 20px;
}

.icon {
  font-size: 2rem;
  display: block;
  margin-bottom: 10px;
}

/* Planos */
.plans {
  padding: 60px 20px;
  text-align: center;
}

.plans h2 {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 30px;
  color: var(--verde-escuro);
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
}

.plan-card {
  background: var(--card);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  text-align: center;
  transition: transform 0.2s;
}

.plan-card:hover {
  transform: translateY(-5px);
}

.plan-card h3 {
  margin: 0 0 10px;
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--verde-claro);
}

.plan-card .price {
  display: block;
  font-size: 1.4rem;
  font-weight: 800;
  margin: 10px 0;
  color: var(--verde-escuro);
}

.plan-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
  color: #444;
  font-size: 0.95rem;
}

.plan-card ul li {
  margin: 6px 0;
}

.plan-card.destaque {
  border: 2px solid var(--verde-escuro);
  transform: scale(1.05);
}

/* Mobile ajustes */
@media (max-width: 768px) {
  .landing-inner {
    flex-direction: column;
    margin-top: 20px;
    text-align: center;
    gap: 20px;
  }

  .headline {
    font-size: 2rem;
  }

  .phone-wrap {
    width: 300px;
    margin: 0 auto;
  }
}
</style>
